module.exports = __webpack_public_path__ + "img/logo.e7dd64a3.png";